(function () {
  'use strict';

  var contactPath = '/contact';
  var verifiedProductContext = {
    bm: { title: 'BM', handle: 'bm', url: '/products/bm' },
    bm2: { title: 'BM2', handle: 'bm2', url: '/products/bm2' },
    champion: { title: 'Champion', handle: 'champion', url: '/products/champion' },
    cs: { title: 'CS', handle: 'cs', url: '/products/cs' },
    fb: { title: 'FB', handle: 'fb', url: '/products/fb' },
    fl: { title: 'FL', handle: 'fl', url: '/products/fl' },
    h9: { title: 'H9', handle: 'h9-1', url: '/products/h9-1' },
    harley: { title: 'Harley', handle: 'harley', url: '/products/harley' },
    knight: { title: 'Knight', handle: 'knight', url: '/products/knight' },
    m1: { title: 'M1', handle: 'm1', url: '/products/m1' },
    m2: { title: 'M2', handle: 'm2', url: '/products/m2' },
    mycq: { title: 'MYCQ', handle: 'mycq-1', url: '/products/mycq-1' },
    zj: { title: 'ZJ', handle: 'zj', url: '/products/zj' },
    ninep: { title: 'Nine P', handle: 'nine-p', url: '/products/nine-p' },
    x3: { title: 'X3', handle: 'x3-2', url: '/products/x3-2' },
    q5: { title: 'Q5', handle: 'q5-1', url: '/products/q5-1' },
    q6: { title: 'Q6', handle: 'q6-1', url: '/products/q6-1' },
    tank: { title: 'Tank', handle: 'tank', url: '/products/tank' },
    xbf: { title: 'XBF', handle: 'xbf-1', url: '/products/xbf-1' },
    q7: { title: 'Q7', handle: 'q7-1', url: '/products/q7-1' },
    q3: { title: 'Q3', handle: 'q3', url: '/products/q3' },
    sn: { title: 'SN', handle: 'sn-1', url: '/products/sn-1' },
    xgz: { title: 'XGZ', handle: 'xgz', url: '/products/xgz' }
  };
  var allowedInquiryTypes = {
    general: true, wholesale_quote: true, dealer: true, oem_project: true,
    solution_inquiry: true, branding: true, power: true, safety: true, smart: true,
    equipment: true, compliance: true, fleet: true, public_sector: true, sample: true,
    after_sales: true, product: true, leave_a_message: true, homepage_quote: true, contact: true
  };
  var inquiryTypeLabels = {
    wholesale_quote: 'Request a Quote',
    oem_project: 'OEM / ODM Project',
    dealer: 'Dealer Partnership',
    fleet: 'Fleet Procurement',
    public_sector: 'Public Sector Project',
    sample: 'Sample Request',
    after_sales: 'After-Sales Support',
    product: 'Request a Quote',
    solution_inquiry: 'OEM / ODM Project',
    general: 'Other Inquiry'
  };
  var sharedInquiryTypeValues = [
    'wholesale_quote', 'oem_project', 'dealer', 'fleet', 'public_sector', 'sample', 'after_sales', 'general'
  ];
  var intendedUseOptions = [
    'Urban Commuting', 'Delivery & Cargo', 'Rental & Shared Mobility',
    'Fleet Operations', 'Other', 'Not Sure — Please Advise'
  ];
  var quantityOptions = [
    'Pilot Project', 'Quantity to Be Confirmed', 'Under 50', '50–99',
    '100–499', '500–999', '1,000–4,999', '5,000+'
  ];
  var businessInquiryPageConfigs = {
    '/pages/oem-manufacturing': {
      type: 'oem_project', button: 'Submit OEM/ODM Inquiry',
      extra: [{ key: 'annual-volume', label: 'Estimated Annual Volume', name: 'contact[annual_volume]', placeholder: 'Optional' }]
    },
    '/pages/dealer-program': {
      type: 'dealer', button: 'Submit Dealer Application', companyRequired: true,
      extra: [
        { key: 'business-type', label: 'Business Type *', name: 'contact[business_type]', type: 'select', required: true,
          options: ['Local Dealer', 'Distributor or Wholesaler', 'Importer', 'Retail Group', 'E-commerce Operator', 'New Business', 'Other'] },
        { key: 'monthly-volume', label: 'Monthly Purchasing Volume', name: 'contact[monthly_purchasing_volume]', placeholder: 'Optional' }
      ]
    },
    '/pages/branding-vehicle-identity': {
      type: 'oem_project', area: 'branding', button: 'Submit Branding Inquiry',
      extra: [
        { key: 'intended-use', label: 'Intended Use', name: 'contact[intended_use]', type: 'select', options: intendedUseOptions },
        { key: 'branding-area', label: 'Primary Customization Area', name: 'contact[customization_area]', type: 'select',
          options: ['Brand Identity / Colors & Graphics', 'Finishes & Details', 'Multiple Areas', 'Other'] },
        { key: 'branding-requirements', label: 'Branding Requirements', name: 'contact[branding_requirements]', type: 'textarea', full: true, placeholder: 'Share logo, color, graphic or finish requirements.' }
      ]
    },
    '/pages/power-charging': {
      type: 'oem_project', area: 'power', button: 'Submit Power & Charging Inquiry',
      extra: [
        { key: 'intended-use', label: 'Intended Use', name: 'contact[intended_use]', type: 'select', options: intendedUseOptions },
        { key: 'power-area', label: 'Power & Charging Area', name: 'contact[power_area]', type: 'select',
          options: ['Battery & Range', 'Motor & Controller', 'Charging Options', 'Complete Power System', 'Not Sure — Please Advise'] }
      ]
    },
    '/pages/safety-ride': {
      type: 'oem_project', area: 'safety', button: 'Submit Safety & Ride Inquiry',
      extra: [{ key: 'intended-use', label: 'Intended Use', name: 'contact[intended_use]', type: 'select', options: intendedUseOptions }]
    },
    '/pages/smart-systems': {
      type: 'oem_project', area: 'smart', button: 'Submit Smart Systems Inquiry',
      extra: [
        { key: 'intended-use', label: 'Intended Use', name: 'contact[intended_use]', type: 'select', options: intendedUseOptions },
        { key: 'smart-area', label: 'Primary Area of Interest', name: 'contact[smart_system_area]', type: 'select',
          options: ['Instrument Display', 'Branded Interface', 'Connected Features', 'Multiple Areas', 'Other'] }
      ]
    },
    '/pages/use-case-equipment': {
      type: 'oem_project', area: 'equipment', button: 'Submit Equipment Inquiry',
      extra: [{ key: 'intended-use', label: 'Intended Use', name: 'contact[intended_use]', type: 'select', options: intendedUseOptions }]
    },
    '/pages/compliance-market-entry': {
      type: 'oem_project', area: 'compliance', button: 'Submit Market Entry Inquiry',
      extra: [
        { key: 'documentation', label: 'Documentation Needed', name: 'contact[documentation_needed]', type: 'select',
          options: ['EU Type Approval', 'CoC', 'Applicable CE Documentation', 'UN 38.3', 'SDS', 'Battery Transport', 'Market-Specific Review', 'Not Sure — Please Advise'] },
        { key: 'delivery-format', label: 'Delivery Format', name: 'contact[delivery_format]', type: 'select', options: ['CBU', 'SKD', 'CKD', 'Not Sure'] }
      ]
    },
    '/pages/certifications': {
      type: 'general', area: 'compliance', button: 'Submit Documentation Inquiry',
      extra: [{ key: 'documentation', label: 'Documentation Needed', name: 'contact[documentation_needed]', type: 'select',
        options: ['EU Type Approval', 'CoC', 'Applicable CE Documentation', 'UN 38.3', 'SDS', 'Battery Transport', 'Market-Specific Review', 'Not Sure — Please Advise'] }]
    },
    '/pages/fleet-solutions': {
      type: 'fleet', button: 'Submit Fleet Inquiry',
      quantityOptions: quantityOptions,
      extra: [
        { key: 'intended-use', label: 'Intended Use', name: 'contact[intended_use]', type: 'select', options: intendedUseOptions }
      ]
    },
    '/pages/government-projects': {
      type: 'public_sector', button: 'Submit Project Inquiry',
      quantityOptions: quantityOptions,
      extra: [
        { key: 'project-type', label: 'Project Type', name: 'contact[project_type]', type: 'select',
          options: ['Public Service Mobility', 'Municipal Operations', 'Institutional Fleet', 'Other'] }
      ]
    }
  };
  var allowedEntryTypes = {
    header_get_quote: true, homepage_wholesale_quote: true, leave_message: true,
    floating_message: true, direct_form: true, product_card: true, solution_cta: true,
    dealer_cta: true, oem_cta: true, sample_cta: true, after_sales_cta: true
  };
  var allowedSolutionAreas = {
    branding: true, power: true, safety: true, smart: true,
    equipment: true, compliance: true, fleet: true, public_sector: true
  };
  var solutionAreaByPath = {
    '/pages/branding-vehicle-identity': 'branding',
    '/pages/power-charging': 'power',
    '/pages/safety-ride': 'safety',
    '/pages/smart-systems': 'smart',
    '/pages/use-case-equipment': 'equipment',
    '/pages/compliance-market-entry': 'compliance',
    '/pages/certifications': 'compliance',
    '/pages/fleet-solutions': 'fleet',
    '/pages/government-projects': 'public_sector'
  };
  var activeModalTrigger = null;
  var bodyOverflowBeforeModal = '';
  var landingPage = '';

  function getQueryValue(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name) || '';
  }

  function addHiddenInput(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function normalizeProductTitle(value) {
    return (value || '').trim().toLowerCase()
      .replace(/^(electric motorcycle|electric scooter|electric bicycle|electric bike)\s*/, '')
      .replace(/[^a-z0-9]/g, '');
  }

  function normalizeInquiryType(value) {
    var normalized = (value || '').trim().toLowerCase();
    if (normalized === 'product_inquiry') normalized = 'product';
    if (normalized === 'general_quote') normalized = 'wholesale_quote';
    return allowedInquiryTypes[normalized] ? normalized : '';
  }

  function normalizeEntryType(value) {
    var normalized = (value || '').trim().toLowerCase();
    return allowedEntryTypes[normalized] ? normalized : '';
  }

  function normalizeSolutionArea(value) {
    var normalized = (value || '').trim().toLowerCase();
    return allowedSolutionAreas[normalized] ? normalized : '';
  }

  function isContactPage() {
    return window.location.pathname === '/pages/contact' ||
      window.location.pathname === '/pages/contact/' || window.location.pathname === contactPath;
  }

  function getFirstPartyLandingPage() {
    try {
      var stored = window.sessionStorage.getItem('mfx_landing_page');
      if (stored) return stored;
      stored = window.location.pathname || '/';
      window.sessionStorage.setItem('mfx_landing_page', stored);
      return stored;
    } catch (error) {
      return window.location.pathname || '/';
    }
  }

  function getProductContext(form) {
    var title = form.dataset.mfxProductTitle || '';
    var handle = form.dataset.mfxProductHandle || '';
    var sourceUrl = form.dataset.mfxSourceUrl || '';
    var productMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    var titleNode = document.querySelector('main[data-template*="product"] h1, main[data-template*="product"] [data-product-title]');

    if (!title && form.id === 'mfxInquiryForm') {
      var productInput = form.querySelector('[name="mfx_product_name"]');
      title = productInput ? productInput.value : '';
    }

    if (!title && titleNode) {
      title = titleNode.textContent.trim();
    }

    if (!handle && productMatch) {
      handle = decodeURIComponent(productMatch[1]);
    }

    if (!sourceUrl) {
      sourceUrl = window.location.origin + window.location.pathname;
    }

    return {
      title: title,
      handle: handle,
      sourceUrl: sourceUrl
    };
  }

  function getInquiryType(form) {
    var modal = form.closest('#contactModal');
    var explicitType = normalizeInquiryType(form.dataset.mfxInquiryType) ||
      normalizeInquiryType(modal && modal.dataset.mfxInquiryType);
    if (explicitType) return explicitType;
    var existingField = form.querySelector('[name="contact[inquiry_type]"]');
    var existingType = normalizeInquiryType(existingField && existingField.value);
    if (existingType) return existingType;
    var queryType = normalizeInquiryType(getQueryValue('inquiry_type'));
    if (queryType) return queryType;
    var pageConfig = businessInquiryPageConfigs[window.location.pathname.replace(/\/$/, '')];
    if (pageConfig) return pageConfig.type;
    if (form.id === 'mfxInquiryForm') return 'product';
    if (form.classList.contains('modernfox-inquiry-form')) return 'homepage_quote';
    if (form.id === 'contactForm') return 'leave_a_message';
    if (window.location.pathname === '/pages/oem-manufacturing') return 'oem_project';
    if (window.location.pathname === '/pages/dealer-program') return 'dealer';
    if (getSolutionArea(form)) return 'solution_inquiry';
    return 'general';
  }

  function getEntryType(form) {
    var modal = form.closest('#contactModal');
    var explicit = normalizeEntryType(form.dataset.mfxEntryType) ||
      normalizeEntryType(modal && modal.dataset.mfxEntryType);
    if (explicit) return explicit;
    var queryValue = normalizeEntryType(getQueryValue('entry_type'));
    if (queryValue) return queryValue;
    return form.id === 'contactForm' ? 'floating_message' : 'direct_form';
  }

  function getSolutionArea(form) {
    return normalizeSolutionArea(form.dataset.mfxSolutionArea) ||
      solutionAreaByPath[window.location.pathname] || '';
  }

  function createInquiryField(definition, idPrefix) {
    var wrapper = document.createElement('div');
    wrapper.className = 'mfx-form-field' + (definition.full ? ' mfx-form-field--full' : '');
    if (definition.key) wrapper.dataset.mfxField = definition.key;
    if (definition.conditional) {
      wrapper.dataset.mfxConditional = definition.conditional;
      wrapper.hidden = true;
    }

    var id = idPrefix + '-' + (definition.key || definition.name.replace(/[^a-z0-9]+/gi, '-').toLowerCase());
    var label = document.createElement('label');
    label.htmlFor = id;
    label.textContent = definition.label;
    wrapper.appendChild(label);

    var control;
    if (definition.type === 'textarea') {
      control = document.createElement('textarea');
    } else if (definition.type === 'select') {
      control = document.createElement('select');
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = definition.placeholder || 'Select an option';
      placeholder.disabled = !!definition.required;
      placeholder.selected = true;
      control.appendChild(placeholder);
      (definition.options || []).forEach(function (option) {
        var item = document.createElement('option');
        item.value = option;
        item.textContent = definition.optionLabels ? (definition.optionLabels[option] || option) : option;
        control.appendChild(item);
      });
    } else {
      control = document.createElement('input');
      control.type = definition.type || 'text';
    }

    control.id = id;
    control.name = definition.name;
    if (definition.required) control.required = true;
    if (definition.placeholder && definition.type !== 'select') control.placeholder = definition.placeholder;
    if (definition.autocomplete) control.autocomplete = definition.autocomplete;
    if (definition.inputmode) control.inputMode = definition.inputmode;
    wrapper.appendChild(control);
    return wrapper;
  }

  function sharedInquiryFields(config, idPrefix, includeInquiryType) {
    var fields = [];
    if (includeInquiryType) {
      fields.push({
        key: 'inquiry-type', label: 'Inquiry Type *', name: 'contact[inquiry_type]', type: 'select', required: true,
        options: sharedInquiryTypeValues, optionLabels: inquiryTypeLabels
      });
    }
    fields.push(
      { key: 'name', label: 'Name *', name: 'contact[name]', required: true, autocomplete: 'name', placeholder: 'Your name' },
      { key: 'business-email', label: 'Business Email *', name: 'contact[email]', type: 'email', required: true, autocomplete: 'email', placeholder: 'name@company.com' },
      { key: 'target-country', label: 'Target Country / Region *', name: 'contact[country]', required: true, autocomplete: 'country-name', placeholder: 'Country or region' },
      { key: 'company', label: config && config.companyRequired ? 'Company *' : 'Company', name: 'contact[company]', required: !!(config && config.companyRequired), autocomplete: 'organization', placeholder: 'Company name' },
      { key: 'model', label: 'Model of Interest', name: 'contact[model]', placeholder: 'Enter a model or note “Not sure” in your requirements' }
    );
    fields.push(config && config.quantityOptions
      ? { key: 'initial-quantity', label: 'Estimated Initial Order Quantity (units)', name: 'contact[order_quantity]', type: 'select', options: config.quantityOptions }
      : { key: 'initial-quantity', label: 'Estimated Initial Order Quantity (units)', name: 'contact[order_quantity]', placeholder: 'Optional' });
    if (config && config.extra) fields = fields.concat(config.extra);
    fields.push(
      { key: 'requirements', label: 'Requirements *', name: 'contact[body]', type: 'textarea', required: true, full: true, placeholder: 'Share your intended use, target market needs and project requirements.' },
      { key: 'whatsapp', label: 'WhatsApp', name: 'contact[whatsapp]', type: 'tel', autocomplete: 'tel', placeholder: 'Country code + phone number' }
    );
    return fields.map(function (field) { return createInquiryField(field, idPrefix); });
  }

  function updateModalInquiryFields(modal, type) {
    if (!modal) return;
    var normalized = normalizeInquiryType(type) || 'wholesale_quote';
    var company = modal.querySelector('[data-mfx-field="company"] input');
    var companyLabel = modal.querySelector('[data-mfx-field="company"] label');
    var annual = modal.querySelector('[data-mfx-field="annual-volume"]');
    var monthly = modal.querySelector('[data-mfx-field="monthly-volume"]');
    if (company) company.required = normalized === 'dealer';
    if (companyLabel) companyLabel.textContent = normalized === 'dealer' ? 'Company *' : 'Company';
    if (annual) annual.hidden = normalized !== 'oem_project';
    if (monthly) monthly.hidden = normalized !== 'dealer';
    modal.dataset.mfxInquiryType = normalized;
  }

  function buildSharedModalForm(modal) {
    var form = modal && modal.querySelector('#contactForm');
    if (!form || form.dataset.mfxSharedForm === 'true') return;
    var panel = modal.querySelector('.modal-content');
    var title = panel && panel.querySelector('.modal-title, h2');
    if (title) title.textContent = 'Discuss Your Project';

    if (title && !panel.querySelector('.mfx-modal-intro')) {
      var intro = document.createElement('p');
      intro.className = 'mfx-modal-intro';
      intro.textContent = 'Tell us about your company, destination market and project requirements.';
      title.insertAdjacentElement('afterend', intro);
    }

    var feedback = form.querySelector('[data-contact-form-feedback]');
    if (feedback && feedback.classList.contains('contact-form-feedback--success')) {
      var feedbackText = feedback.querySelector('p');
      if (feedbackText) feedbackText.textContent = 'Thank you for your inquiry. Our team will review your requirements and contact you during business hours.';
    }
    var hiddenFields = Array.prototype.slice.call(form.querySelectorAll('input[type="hidden"]'));
    form.innerHTML = '';
    hiddenFields.forEach(function (input) { form.appendChild(input); });
    if (feedback) form.appendChild(feedback);

    var grid = document.createElement('div');
    grid.className = 'mfx-shared-form-fields';
    sharedInquiryFields({ extra: [
      { key: 'annual-volume', label: 'Estimated Annual Volume', name: 'contact[annual_volume]', conditional: 'oem_project', placeholder: 'Optional' },
      { key: 'monthly-volume', label: 'Monthly Purchasing Volume', name: 'contact[monthly_purchasing_volume]', conditional: 'dealer', placeholder: 'Optional' }
    ] }, 'mfx-modal', true).forEach(function (field) { grid.appendChild(field); });
    form.appendChild(grid);

    var typeSelect = form.querySelector('select[name="contact[inquiry_type]"]');
    if (typeSelect) {
      typeSelect.value = 'wholesale_quote';
      typeSelect.addEventListener('change', function () {
        modal.dataset.mfxInquiryType = normalizeInquiryType(typeSelect.value) || 'wholesale_quote';
        updateModalInquiryFields(modal, typeSelect.value);
      });
    }

    var submit = document.createElement('button');
    submit.type = 'submit';
    submit.className = 'modal-submit';
    submit.textContent = 'Send Inquiry';
    form.appendChild(submit);
    form.dataset.mfxSharedForm = 'true';
    form.classList.add('mfx-shared-form');
    updateModalInquiryFields(modal, 'wholesale_quote');
  }

  function rebuildBusinessInquiryForms() {
    var path = window.location.pathname.replace(/\/$/, '');
    var config = businessInquiryPageConfigs[path];
    if (!config) return;
    document.querySelectorAll('form').forEach(function (form) {
      if (form.id === 'contactForm' || form.classList.contains('email-signup__form') || form.dataset.mfxSharedForm === 'true') return;
      if (!isContactForm(form)) return;

      var heading = form.querySelector('.mf-form-title, h2');
      var headingText = heading ? heading.textContent.trim() : '';
      var hiddenFields = Array.prototype.slice.call(form.querySelectorAll('input[type="hidden"]'));
      form.innerHTML = '';
      hiddenFields.forEach(function (input) { form.appendChild(input); });
      if (headingText) {
        var headingNode = document.createElement('h2');
        headingNode.className = 'mfx-shared-form-title';
        headingNode.textContent = headingText;
        form.appendChild(headingNode);
      }

      var grid = document.createElement('div');
      grid.className = 'mfx-shared-form-fields';
      sharedInquiryFields(config, 'mfx-page', false).forEach(function (field) { grid.appendChild(field); });
      form.appendChild(grid);
      form.method = 'post';
      if (!form.getAttribute('action')) form.action = '/contact#contact_form';
      form.dataset.mfxSharedForm = 'true';
      form.dataset.mfxInquiryType = config.type;
      form.classList.add('mfx-shared-form');
      if (config.area) form.dataset.mfxSolutionArea = config.area;

      var submit = document.createElement('button');
      submit.type = 'submit';
      submit.className = 'mfx-shared-form-submit';
      submit.textContent = config.button;
      form.appendChild(submit);

      var note = document.createElement('p');
      note.className = 'mfx-shared-form-note';
      note.textContent = path === '/pages/dealer-program' || path === '/pages/solutions'
        ? 'We review dealer applications during business hours. If your business matches the program requirements, our team will contact you to discuss the next steps. For samples or one-time purchases, please request a quotation.'
        : 'Project requirements and next steps are confirmed for each inquiry.';
      form.appendChild(note);
    });
  }

  function applyHomepageCopy() {
    if (window.location.pathname !== '/') return;
    var hero = document.querySelector('.mfx-hero');
    if (hero) {
      var h1 = hero.querySelector('h1');
      var paragraphs = hero.querySelectorAll('.mfx-hero-content > p');
      if (h1) h1.textContent = 'Electric Scooter & Motorcycle Manufacturer';
      if (paragraphs.length > 1) {
        paragraphs[1].textContent = 'Our own factory supports dealers, importers and brand owners with vehicle manufacturing and OEM/ODM customization for their markets.';
      }
      var trustBar = hero.querySelector('.hero-trust-bar');
      if (trustBar) {
        var trustLabels = [
          'Market-Specific Compliance Support', 'Quality Management — ISO 9001',
          'Manufacturer Identity — WMI', 'Vehicle Approval — Selected Models',
          'Battery Transport Documentation — UN 38.3 / SDS'
        ];
        var oldIcons = Array.prototype.slice.call(trustBar.querySelectorAll('.hero-trust-item svg'));
        trustBar.innerHTML = '';
        trustLabels.forEach(function (label, index) {
          if (index) {
            var divider = document.createElement('div');
            divider.className = 'hero-trust-divider';
            trustBar.appendChild(divider);
          }
          var item = document.createElement('div');
          item.className = 'hero-trust-item';
          if (oldIcons[index] || oldIcons[0]) item.appendChild((oldIcons[index] || oldIcons[0]).cloneNode(true));
          var span = document.createElement('span');
          span.textContent = label;
          item.appendChild(span);
          trustBar.appendChild(item);
        });
      }
    }

    var complianceCredentials = document.querySelector('#mfx-body-compliance .mfx-body-compliance__credentials');
    if (complianceCredentials) {
      var credentials = [
        ['Market-Specific Compliance Support', 'Reviewed by model and destination', 'tabler/shield-check'],
        ['Quality Management', 'ISO 9001', 'tabler/certificate'],
        ['Manufacturer Identity', 'WMI', 'tabler/id'],
        ['Vehicle Approval', 'Selected Models', 'tabler/motorbike'],
        ['Battery Transport Documentation', 'UN 38.3 / SDS', 'tabler/battery']
      ];
      complianceCredentials.innerHTML = '';
      credentials.forEach(function (entry) {
        var card = document.createElement('div');
        card.className = 'mfx-body-compliance__credential';
        var icon = document.createElement('img');
        icon.alt = '';
        icon.loading = 'lazy';
        icon.src = 'https://api.iconify.design/' + entry[2] + '.svg?color=%230078d7';
        var copy = document.createElement('div');
        var title = document.createElement('h3');
        title.textContent = entry[0];
        var detail = document.createElement('small');
        detail.textContent = entry[1];
        copy.appendChild(title);
        copy.appendChild(detail);
        card.appendChild(icon);
        card.appendChild(copy);
        complianceCredentials.appendChild(card);
      });
    }

    var footerPoints = document.querySelector('.mf-footer .mf-brand__points');
    if (footerPoints) {
      var badges = [
        'Market-Specific Compliance Support', 'Quality Management — ISO 9001',
        'Manufacturer Identity — WMI', 'Vehicle Approval — Selected Models',
        'Battery Transport Documentation — UN 38.3 / SDS'
      ];
      footerPoints.innerHTML = '';
      badges.forEach(function (label) {
        var item = document.createElement('li');
        item.textContent = label;
        footerPoints.appendChild(item);
      });
    }

    // Homepage FAQ is rendered directly by its Liquid section.

  }

  function normalizeFooterBadges() {
    var footerPoints = document.querySelector('.mf-footer .mf-brand__points');
    if (!footerPoints) return;
    var badges = [
      'Market-Specific Compliance Support', 'Quality Management — ISO 9001',
      'Manufacturer Identity — WMI', 'Vehicle Approval — Selected Models',
      'Battery Transport Documentation — UN 38.3 / SDS'
    ];
    footerPoints.innerHTML = '';
    badges.forEach(function (label) {
      var item = document.createElement('li');
      item.textContent = label;
      footerPoints.appendChild(item);
    });
  }

  function cleanEmptyBlogTemplate() {
    if (window.location.pathname.indexOf('/blogs/') !== 0) return;
    var mainBlog = document.querySelector('#MainContent .blog-posts, #MainContent [data-blog-posts], #MainContent .main-blog');
    var hasArticles = mainBlog ? mainBlog.querySelectorAll('article, .blog-post-card, .blog-articles__article').length > 0 :
      document.querySelectorAll('#MainContent article').length > 0;
    if (hasArticles) return;
    if (mainBlog) {
      var blogSection = mainBlog.closest('.shopify-section');
      if (blogSection) blogSection.remove();
      else mainBlog.remove();
    }
    var title = document.querySelector('#MainContent .shopify-section h1, #MainContent h1');
    if (title) title.textContent = 'Electric Mobility Insights';
    document.querySelectorAll('#MainContent p').forEach(function (paragraph) {
      if (/expert insights|market trends|business knowledge/i.test(paragraph.textContent)) paragraph.remove();
    });
    document.querySelectorAll('#MainContent .shopify-section').forEach(function (section) {
      var content = section.textContent || '';
      if (/Stay Ahead Of The Market|Receive industry insights|We create with intention|We obsess over the details|We're always on your side/i.test(content)) section.remove();
    });
    document.querySelectorAll('#MainContent a').forEach(function (link) {
      if (link.textContent.trim() === 'Explore Products') link.setAttribute('href', '/pages/products');
    });
  }

  function showContactPostedConfirmation() {
    if (getQueryValue('contact_posted') !== 'true') return;
    var form = document.querySelector('#MainContent form.mfx-shared-form');
    if (!form || form.querySelector('.mfx-form-confirmation')) return;
    var status = document.createElement('p');
    status.className = 'mfx-form-confirmation';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.textContent = 'Thank you for your inquiry. Our team will review your requirements and contact you during business hours.';
    form.insertAdjacentElement('beforebegin', status);
  }

  function prepareContactForm(form) {
    if (form.id === 'contactForm') {
      var name = form.querySelector('[name="fullName"]');
      var email = form.querySelector('[name="email"]');
      var phone = form.querySelector('[name="phone"]');
      var message = form.querySelector('[name="message"]');
      if (name) name.name = 'contact[name]';
      if (email) email.name = 'contact[email]';
      if (phone) phone.name = 'contact[phone]';
      if (message) message.name = 'contact[body]';
      form.method = 'post';
      form.action = contactPath + '#contact_form';
      addHiddenInput(form, 'form_type', 'contact');
      addHiddenInput(form, 'utf8', '✓');
      addHiddenInput(form, 'contact[subject]', 'Leave a Message');
    }

    var company = form.querySelector('[name="mfx_company"]');
    var quantity = form.querySelector('[name="mfx_quantity"]');
    if (company) company.name = 'contact[company]';
    if (quantity) quantity.name = 'contact[order_quantity]';

    var context = getProductContext(form);
    var inquiryType = getInquiryType(form);
    var entryType = getEntryType(form);
    var solutionArea = getSolutionArea(form);
    var visibleInquiryType = form.querySelector('select[name="contact[inquiry_type]"]');
    if (visibleInquiryType) {
      visibleInquiryType.value = inquiryType;
      var modal = form.closest('#contactModal');
      if (modal) modal.dataset.mfxInquiryType = inquiryType;
    } else {
      addHiddenInput(form, 'contact[inquiry_type]', inquiryType);
    }
    addHiddenInput(form, 'contact[inquiry_type_label]', inquiryTypeLabels[inquiryType] || 'Other Inquiry');
    addHiddenInput(form, 'contact[subject]', 'ModernFox — ' + (inquiryTypeLabels[inquiryType] || 'Other Inquiry'));
    addHiddenInput(form, 'contact[entry_type]', entryType);
    addHiddenInput(form, 'contact[form_page]', window.location.pathname);
    addHiddenInput(form, 'contact[landing_page]', landingPage || window.location.pathname);
    if (context.title && context.handle) {
      addHiddenInput(form, 'contact[product_title]', context.title);
      addHiddenInput(form, 'contact[product_handle]', context.handle);
    }
    if (context.sourceUrl) addHiddenInput(form, 'contact[source_url]', context.sourceUrl);
    if (solutionArea) addHiddenInput(form, 'contact[solution_area]', solutionArea);
    if (context.title) addHiddenInput(form, 'contact[model]', context.title);
    if (form.id !== 'contactForm' && !isContactPage()) {
      addHiddenInput(form, 'return_to', window.location.pathname + '?contact_posted=true');
    }
  }

  function isContactForm(form) {
    var action = (form.getAttribute('action') || '').split('#')[0];
    return action === contactPath || action.slice(-contactPath.length) === contactPath || form.id === 'contactForm';
  }

  function setInquiryLink(link, type, entryType) {
    var url = new URL(link.href, window.location.origin);
    var safeType = normalizeInquiryType(type);
    var safeEntry = normalizeEntryType(entryType);
    if (safeType) url.searchParams.set('inquiry_type', safeType);
    if (safeEntry) url.searchParams.set('entry_type', safeEntry);
    link.href = url.pathname + url.search + url.hash;
  }

  function getLinkIntent(link) {
    var text = link.textContent.trim().toLowerCase();
    if (text.indexOf('get wholesale quote') !== -1) {
      return { type: 'wholesale_quote', entry: 'homepage_wholesale_quote' };
    }
    if (text.indexOf('get quote') !== -1 || text.indexOf('request a quote') !== -1 ||
      text.indexOf('product inquiry') !== -1) {
      return {
        type: window.location.pathname.indexOf('/products/') === 0 ? 'product' : 'wholesale_quote',
        entry: link.closest('header') ? 'header_get_quote' : 'solution_cta'
      };
    }
    if (text.indexOf('leave a message') !== -1 || text.indexOf('send us a message') !== -1) {
      return { type: 'general', entry: 'leave_message' };
    }
    if (text.indexOf('sample') !== -1) return { type: 'sample', entry: 'sample_cta' };
    if (text.indexOf('after-sales') !== -1 || text.indexOf('after sales') !== -1) {
      return { type: 'after_sales', entry: 'after_sales_cta' };
    }
    if (text.indexOf('oem') !== -1 || text.indexOf('customization') !== -1) {
      return { type: 'oem_project', entry: 'oem_cta' };
    }
    if (text.indexOf('fleet') !== -1) return { type: 'fleet', entry: 'solution_cta' };
    if (text.indexOf('public sector') !== -1 || text.indexOf('government') !== -1) {
      return { type: 'public_sector', entry: 'solution_cta' };
    }
    if (text.indexOf('dealer') !== -1 || text.indexOf('dealership') !== -1) {
      return { type: 'dealer', entry: 'dealer_cta' };
    }
    return null;
  }

  function enrichCallToActions() {
    if (isContactPage() || window.location.pathname.indexOf('/products/') === 0) return;

    document.querySelectorAll('a[href*="/pages/contact"]').forEach(function (link) {
      var text = link.textContent.trim().toLowerCase();
      if (text.indexOf('become a dealer') !== -1 || text.indexOf('dealer opportunities') !== -1) {
        var dealerUrl = new URL('/pages/dealer-program', window.location.origin);
        dealerUrl.searchParams.set('inquiry_type', 'dealer');
        dealerUrl.searchParams.set('entry_type', 'dealer_cta');
        link.href = dealerUrl.pathname + dealerUrl.search;
        return;
      }
      var intent = getLinkIntent(link);
      if (intent) setInquiryLink(link, intent.type, intent.entry);
    });

    document.querySelectorAll('a[href*="/collections/all"]').forEach(function (link) {
      if (link.textContent.trim().toLowerCase().indexOf('discuss oem project') !== -1) {
        link.href = '/pages/oem-manufacturing#oem-inquiry';
      }
    });

    document.querySelectorAll('a[href]').forEach(function (link) {
      var text = link.textContent.trim().toLowerCase();
      if (text.indexOf('explore oem solutions') !== -1) {
        link.href = '/pages/oem-manufacturing#oem-inquiry';
      } else if (text.indexOf('explore dealer partnership') !== -1) {
        link.href = '/pages/dealer-program#apply';
      }
    });
  }

  function normalizeConfirmedContactLinks() {
    document.querySelectorAll('a.phone-btn').forEach(function (link) {
      link.href = 'tel:+8675528902097';
    });
  }

  function enrichVerifiedProductCards() {
    document.querySelectorAll('.mfx-product-card').forEach(function (card) {
      var nameNode = card.querySelector('.mfx-product-name');
      if (!nameNode) return;

      var cardTitle = nameNode.textContent.trim();
      var productContext = verifiedProductContext[normalizeProductTitle(cardTitle)];
      if (!productContext) return;

      card.dataset.mfxProductTitle = productContext.title;
      card.dataset.mfxProductHandle = productContext.handle;
      card.dataset.mfxProductUrl = productContext.url;

      var link = card.querySelector('.mfx-product-link');
      if (!link) {
        link = document.createElement('a');
        link.className = 'mfx-product-link';
        link.textContent = 'View Product';
        var cta = card.querySelector('.mfx-product-cta');
        if (cta) cta.parentNode.insertBefore(link, cta);
      }
      link.href = productContext.url;
      link.dataset.mfxProductHandle = productContext.handle;
      link.setAttribute('aria-label', 'View ' + productContext.title + ' product details');
    });
  }

  function repairRecommendedModels() {
    var products = [
      { title: 'BM', handle: 'bm', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC07937.png?v=1789381261' },
      { title: 'BM2', handle: 'bm2', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC08010.png?v=1789381903' },
      { title: 'Champion', handle: 'champion', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC07901.png?v=1789382483' },
      { title: 'CS', handle: 'cs', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC07854.png?v=1789382967' },
      { title: 'FB', handle: 'fb', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC08043.png?v=1789383316' },
      { title: 'FL', handle: 'fl', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC07978.png?v=1789383650' },
      { title: 'H9', handle: 'h9-1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_3803.png?v=1789384008' },
      { title: 'Harley', handle: 'harley', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/2026-08-29_133415_402.png?v=1789384423' },
      { title: 'Knight', handle: 'knight', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC01607.png?v=1789384760' },
      { title: 'M1', handle: 'm1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_0308.png?v=1789378824' },
      { title: 'M2', handle: 'm2', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/2026-09-10_154608_631.png?v=1789380203' },
      { title: 'MYCQ', handle: 'mycq-1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_9105.png?v=1789385102' },
      { title: 'Nine P', handle: 'nine-p', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/e20600fdaf03629677c0e37ed53082bb.png?v=1789385458' },
      { title: 'Q3', handle: 'q3', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_8910.png?v=1789385873' },
      { title: 'Q5', handle: 'q5-1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_8916_ff3e3398-4d6a-417b-a1a2-98b6664eaa73.png?v=1789386441' },
      { title: 'Q6', handle: 'q6-1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_9058.png?v=1789386896' },
      { title: 'Q7', handle: 'q7-1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/2026-08-20_161907_869.png?v=1789387381' },
      { title: 'SN', handle: 'sn-1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/5a8195c5aaadb235bee1035a302a1d0a.png?v=1789387915' },
      { title: 'Tank', handle: 'tank', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/2026-08-29_133800_099.png?v=1789388466' },
      { title: 'X3', handle: 'x3-2', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/1_c5240dad-7924-49d7-83b9-0a96c136e5a3.png?v=1789389031' },
      { title: 'XBF', handle: 'xbf-1', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_0043.png?v=1789389616' },
      { title: 'XGZ', handle: 'xgz', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC_0618.png?v=1789390133' },
      { title: 'ZJ', handle: 'zj', image: 'https://cdn.shopify.com/s/files/1/0746/4619/2263/files/DSC07794.png?v=1789390683' }
    ];
    var track = document.querySelector('.mf-recommended-models__track');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.mf-model-card'));
    if (!cards.length) return;

    var shuffledProducts = products.slice();
    for (var i = shuffledProducts.length - 1; i > 0; i -= 1) {
      var randomIndex = Math.floor(Math.random() * (i + 1));
      var product = shuffledProducts[i];
      shuffledProducts[i] = shuffledProducts[randomIndex];
      shuffledProducts[randomIndex] = product;
    }

    cards.forEach(function (card, index) {
      var selected = shuffledProducts[index % shuffledProducts.length];
      var link = card.querySelector('.mf-model-card__link');
      if (!link) {
        link = document.createElement('a');
        link.className = 'mf-model-card__link';
        card.textContent = '';
        card.appendChild(link);
      }

      var image = link.querySelector('.mf-model-card__image');
      if (!image) {
        image = document.createElement('img');
        image.className = 'mf-model-card__image';
        link.insertBefore(image, link.firstChild);
      }

      var name = link.querySelector('.mf-model-card__name');
      if (!name) {
        name = document.createElement('figcaption');
        name.className = 'mf-model-card__name';
        link.appendChild(name);
      }

      link.href = '/products/' + selected.handle;
      link.setAttribute('aria-label', 'View ' + selected.title + ' product');
      image.src = selected.image + '&width=800';
      image.alt = selected.title;
      image.loading = 'lazy';
      image.decoding = 'async';
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      name.textContent = selected.title;
      card.dataset.productHandle = selected.handle;
      card.dataset.productTitle = selected.title;
    });
  }

  function normalizeEditorialPageHeadings() {
    var path = window.location.pathname;
    if (path.indexOf('/blogs/') !== 0 && path.indexOf('/collections/') !== 0) return;
    var headings = document.querySelectorAll('h1');
    for (var i = 1; i < headings.length; i += 1) {
      var replacement = document.createElement('h2');
      Array.prototype.forEach.call(headings[i].attributes, function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      while (headings[i].firstChild) replacement.appendChild(headings[i].firstChild);
      headings[i].parentNode.replaceChild(replacement, headings[i]);
    }
  }

  function getFocusableElements(modal) {
    return Array.prototype.slice.call(modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.getAttribute('aria-hidden') !== 'true' && element.offsetParent !== null;
    });
  }

  function openContactModal(trigger, inquiryType, entryType) {
    var modal = document.getElementById('contactModal');
    if (!modal) return false;
    activeModalTrigger = trigger || document.activeElement;
    modal.dataset.mfxInquiryType = normalizeInquiryType(inquiryType) || 'wholesale_quote';
    modal.dataset.mfxEntryType = normalizeEntryType(entryType) || 'floating_message';
    updateModalInquiryFields(modal, modal.dataset.mfxInquiryType);
    var inquirySelect = modal.querySelector('select[name="contact[inquiry_type]"]');
    if (inquirySelect) inquirySelect.value = modal.dataset.mfxInquiryType;
    modal.classList.add('show');
    modal.setAttribute('aria-hidden', 'false');
    bodyOverflowBeforeModal = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    if (activeModalTrigger && activeModalTrigger.setAttribute) {
      activeModalTrigger.setAttribute('aria-haspopup', 'dialog');
      activeModalTrigger.setAttribute('aria-controls', 'contactModal');
      activeModalTrigger.setAttribute('aria-expanded', 'true');
    }
    window.requestAnimationFrame(function () {
      var target = modal.querySelector('input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])') ||
        modal.querySelector('.modal-content');
      if (target && typeof target.focus === 'function') target.focus();
    });
    return true;
  }

  function closeContactModal() {
    var modal = document.getElementById('contactModal');
    if (!modal) return;
    modal.classList.remove('show');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = bodyOverflowBeforeModal;
    if (activeModalTrigger) {
      activeModalTrigger.setAttribute('aria-expanded', 'false');
      if (document.documentElement.contains(activeModalTrigger) &&
        typeof activeModalTrigger.focus === 'function') activeModalTrigger.focus();
    }
    activeModalTrigger = null;
  }

  function setupContactModal() {
    var modal = document.getElementById('contactModal');
    if (!modal) return;
    buildSharedModalForm(modal);
    var title = modal.querySelector('.modal-title, h2');
    if (title) {
      if (!title.id) title.id = 'mfxContactModalTitle';
      modal.setAttribute('aria-labelledby', title.id);
    }
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    var panel = modal.querySelector('.modal-content');
    if (panel && !panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');

    var ids = { fullName: 'mfxContactFullName', email: 'mfxContactEmail', phone: 'mfxContactPhone', message: 'mfxContactMessage' };
    Object.keys(ids).forEach(function (oldId) {
      var field = modal.querySelector('#' + oldId);
      if (!field) return;
      field.id = ids[oldId];
      var label = modal.querySelector('label[for="' + oldId + '"]');
      if (label) label.htmlFor = ids[oldId];
    });

    var trigger = document.getElementById('openFormBtn');
    if (trigger) {
      trigger.setAttribute('aria-controls', 'contactModal');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
    }
    if (modal.querySelector('[data-contact-form-feedback]')) {
      var postedFeedback = modal.querySelector('.contact-form-feedback--success p');
      if (postedFeedback) postedFeedback.textContent = 'Thank you for your inquiry. Our team will review your requirements and contact you during business hours.';
      openContactModal(trigger, 'wholesale_quote', 'floating_message');
    }
  }

  function addPrivacyLinks() {
    document.querySelectorAll('form').forEach(function (form) {
      if (form.classList.contains('email-signup__form') || !isContactForm(form)) return;
      if (form.querySelector('[data-mfx-privacy-link]')) return;
      var note = document.createElement('p');
      note.setAttribute('data-mfx-privacy-link', '');
      note.className = 'mfx-privacy-note';
      var link = document.createElement('a');
      link.href = '/policies/privacy-policy';
      link.textContent = 'Privacy Policy';
      note.appendChild(link);
      form.appendChild(note);
    });

    var footer = document.querySelector('footer.mf-footer');
    if (footer && !footer.querySelector('a[href="/policies/privacy-policy"]')) {
      var footerNote = document.createElement('p');
      footerNote.className = 'mfx-footer-privacy-note';
      footerNote.style.cssText = 'margin:0;padding:14px 20px;text-align:center;border-top:1px solid #1e1e1e;font-size:12px;';
      var footerLink = document.createElement('a');
      footerLink.href = '/policies/privacy-policy';
      footerLink.textContent = 'Privacy Policy';
      footerLink.style.color = '#aaa';
      footerNote.appendChild(footerLink);
      footer.appendChild(footerNote);
    }
  }

  function normalizeContactFieldTypes() {
    document.querySelectorAll('form').forEach(function (form) {
      form.querySelectorAll('input[name*="email"], input#email').forEach(function (input) { input.type = 'email'; });
      form.querySelectorAll('input[name*="phone"], input[name*="whatsapp"], input#phone').forEach(function (input) {
        input.type = 'tel';
      });
    });
  }

  function restorePendingForm(form) {
    if (!form) return;
    form.removeAttribute('aria-busy');
    form.dataset.mfxSubmitPending = 'false';
    form.querySelectorAll('[data-mfx-submit-pending="true"]').forEach(function (control) {
      control.disabled = false;
      var label = control.dataset.mfxSubmitLabel || 'Send Message';
      if (control.tagName === 'INPUT') control.value = label;
      else control.textContent = label;
      control.removeAttribute('data-mfx-submit-pending');
    });
  }

  function showSubmitRecoveryMessage(form) {
    if (form.querySelector('[data-mfx-submit-status]')) return;
    var status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('data-mfx-submit-status', '');
    status.textContent = 'We could not confirm submission. Please check your connection and try again.';
    form.appendChild(status);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href*="/pages/contact"]') : null;
    if (link && !isContactPage() && window.location.pathname.indexOf('/products/') !== 0) {
      var intent = getLinkIntent(link);
      if (intent && openContactModal(link, intent.type, intent.entry)) {
        event.preventDefault();
        return;
      }
    }
    var openButton = event.target.closest ? event.target.closest('#openFormBtn') : null;
    if (openButton) {
      openContactModal(openButton, 'general', 'floating_message');
      return;
    }
    if (event.target.closest && event.target.closest('#closeModalBtn')) {
      closeContactModal();
      return;
    }
    var modal = document.getElementById('contactModal');
    if (modal && event.target === modal && modal.getAttribute('aria-hidden') === 'false') closeContactModal();

    var quoteButton = event.target.closest ? event.target.closest('.mfx-quote-btn') : null;
    if (!quoteButton) return;
    var form = document.getElementById('mfxInquiryForm');
    var card = quoteButton.closest('.mfx-product-card');
    var nameNode = card ? card.querySelector('.mfx-product-name') : null;
    if (form) {
      var cardTitle = nameNode ? nameNode.textContent.trim() : '';
      var verifiedContext = verifiedProductContext[normalizeProductTitle(cardTitle)];
      form.dataset.mfxProductTitle = verifiedContext ? verifiedContext.title : cardTitle;
      form.dataset.mfxProductHandle = verifiedContext ? verifiedContext.handle : '';
      form.dataset.mfxSourceUrl = window.location.origin + window.location.pathname;
      form.dataset.mfxInquiryType = 'product';
      form.dataset.mfxEntryType = 'product_card';
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    var modal = document.getElementById('contactModal');
    if (!modal) return;
    if (event.key === 'Escape') {
      if (modal.classList.contains('show') || modal.getAttribute('aria-hidden') === 'false') {
        event.preventDefault();
        closeContactModal();
      }
      return;
    }
    if (!modal.classList.contains('show') || event.key !== 'Tab') return;
    var focusable = getFocusableElements(modal);
    if (!focusable.length) {
      event.preventDefault();
      var panel = modal.querySelector('.modal-content');
      if (panel) panel.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  function preventDuplicateSubmission(form) {
    if (form.dataset.mfxSubmitPending === 'true') return;
    form.dataset.mfxSubmitPending = 'true';
    form.setAttribute('aria-busy', 'true');
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (control) {
      if (control.dataset.mfxSubmitPending === 'true') return;
      control.dataset.mfxSubmitPending = 'true';
      control.dataset.mfxSubmitLabel = control.tagName === 'INPUT' ? control.value : control.textContent;
      control.disabled = true;
      if (control.tagName === 'INPUT') {
        control.value = 'Sending...';
      } else {
        control.textContent = 'Sending...';
      }
    });
    window.setTimeout(function () {
      if (form.isConnected && form.dataset.mfxSubmitPending === 'true') {
        restorePendingForm(form);
        showSubmitRecoveryMessage(form);
      }
    }, 45000);
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !isContactForm(form) || form.classList.contains('email-signup__form')) return;
    prepareContactForm(form);
    preventDuplicateSubmission(form);
  }, true);

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('form[data-mfx-submit-pending="true"]').forEach(restorePendingForm);
  });

  function initializeRemediation() {
    landingPage = getFirstPartyLandingPage();
    rebuildBusinessInquiryForms();
    setupContactModal();
    addPrivacyLinks();
    normalizeContactFieldTypes();
    enrichCallToActions();
    normalizeConfirmedContactLinks();
    enrichVerifiedProductCards();
    repairRecommendedModels();
    normalizeEditorialPageHeadings();
    applyHomepageCopy();
    normalizeFooterBadges();
    cleanEmptyBlogTemplate();
    showContactPostedConfirmation();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRemediation);
  else initializeRemediation();
})();
